export default {
  namespaced: true,
  state: {
    imageAttachmentThumbnail: {},
    imageAttachmentSource: {},
  },
  mutations: {
    setImageAttachmentThumbnail(state, { conversationId, attachmentId, source }) {
      if (!state.imageAttachmentThumbnail[conversationId]) {
        state.imageAttachmentThumbnail[conversationId] = {};
      }
      state.imageAttachmentThumbnail[conversationId][attachmentId] = source;
    },
    setImageAttachmentSource(state, { conversationId, attachmentId, source }) {
      if (!state.imageAttachmentSource[conversationId]) {
        state.imageAttachmentSource[conversationId] = {};
      }
      state.imageAttachmentSource[conversationId][attachmentId] = source;
    },
  },
};